import { useLayers } from 'hooks/queries/layers/useLayers'
import { useModalStore } from 'hooks/stores/useModalStore'
import { useCallback, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Layer } from 'types'
import { LayerInaccessibleModal } from 'components/LayerInaccessibleModal/LayerInaccessibleModal'

interface Props {
  articleKey: string
  currentLayerId?: string
}

type LayerSnapshot = Pick<Layer, 'name' | 'color'>

export const useInaccessibleLayerAlert = ({ articleKey, currentLayerId }: Props) => {
  const { data, isLoading } = useLayers({ articleKey })
  const currentLayer = data?.layers.find((layer) => layer.id === currentLayerId)
  const { openModal, closeModal } = useModalStore()
  const history = useHistory()
  const { search } = useLocation()
  const [layer, setLayer] = useState<LayerSnapshot>()

  const showAlert = useCallback(() => {
    const params = new URLSearchParams(search)
    params.delete('layer')
    history.replace({ search: params.toString() })

    openModal(LayerInaccessibleModal, {
      customModal: true,
      modalProps: {
        isOpen: true,
        onClose: closeModal,
        layer,
      },
    })
  }, [history, layer, openModal, closeModal, search])

  /** Take snapshot of current layer data to show after it becomes inaccessible */
  useEffect(() => {
    if (!currentLayer) {
      return
    }

    setLayer({
      name: currentLayer.name,
      color: currentLayer.color,
    })
  }, [currentLayer])

  useEffect(() => {
    if (isLoading || !currentLayerId) {
      return
    }

    if (!currentLayer) {
      showAlert()
    }
  }, [currentLayer, currentLayerId, isLoading, showAlert])
}
